import React from 'react';
import PropTypes from 'prop-types';

import PresentationTopBar from './presentation.top_bar.jsx';
import PresentationBottomBar from './presentation.bottom_bar.jsx';


const PresentationWrapper = ({
  height,
  slides,
  currentSlideIdx,
  displayFilename,
  canDownloadAsset,
  children,
  onClick,
  onNextClick,
  onPrevClick,
  onGoToSlideClick,
  onDownloadClick,
  onFullscreenClick
}) => (
  <div
    className="presentation-wrapper"
    onClick={onClick}
    style={{ height }}
  >

    <PresentationTopBar
      displayFilename={displayFilename}
      canDownloadAsset={canDownloadAsset}
      onDownloadClick={onDownloadClick}
    />

    { children }

    <PresentationBottomBar
      slides={slides}
      currentSlideIdx={currentSlideIdx}
      totalSlides={slides.length}
      onNextClick={onNextClick}
      onPrevClick={onPrevClick}
      onGoToSlideClick={onGoToSlideClick}
      onFullscreenClick={onFullscreenClick}
    />

  </div>
);

PresentationWrapper.propTypes = {
  height: PropTypes.number,
  slides: PropTypes.array.isRequired,
  currentSlideIdx: PropTypes.number.isRequired,
  displayFilename: PropTypes.string.isRequired,
  canDownloadAsset: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  onNextClick: PropTypes.func.isRequired,
  onPrevClick: PropTypes.func.isRequired,
  onGoToSlideClick: PropTypes.func.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onFullscreenClick: PropTypes.func.isRequired
};

export default PresentationWrapper;
